module.exports = __webpack_public_path__ + "public/img/06.680ae0f7.png";